import { useEffect, useState } from 'react';
import { listPaymentStructure } from 'services/billingServices';

export function usePaymentStructure() {
  const [List, setList] = useState([]);

  const loadPaymentStructure = () => {
    listPaymentStructure()
      .then((response) => {
        if (response?.data?.payment_structures) {
          setList(response.data.payment_structures || []);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    loadPaymentStructure();
  }, []);

  return { paymentMethods: List };
}
